import axios from 'axios';

import { createAuthRefreshInterceptor } from './apiAuthRefresh';

const axiosInstance = axios.create();

const api = createAuthRefreshInterceptor(axiosInstance);

export default api;



// WEBPACK FOOTER //
// ./src/services/api/apiConfig.ts